import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-landing-footer',
  templateUrl: './landing-footer.component.html',
  styleUrls: ['./landing-footer.component.scss']
})

export class LandingFooterComponent implements OnInit {
  isShowContact = false;
  mode:number = 0;
  constructor(
    private router: Router,
  ) { }

  ngOnInit(): void {
  }
  moveContact(){
    this.router.navigate(["pages/platform/contact"]);
  }
  movePrivacy(){
    this.router.navigate(["pages/platform/privacy"]);
  }
  getManualSchool() {
    window.open("https://fukuoka-prod-file.s3.ap-northeast-1.amazonaws.com/common/%E3%83%9E%E3%83%8B%E3%83%A5%E3%82%A2%E3%83%AB/%E3%82%B3%E3%83%89%E3%83%A2%E3%83%9F%E3%83%A9%E3%82%A4%E3%82%B3%E3%83%8D%E3%82%AF%E3%83%88%E3%82%B5%E3%83%BC%E3%83%93%E3%82%B9%E3%83%9E%E3%83%8B%E3%83%A5%E3%82%A2%E3%83%AB%EF%BC%88%E4%B8%AD%E5%AD%A6%E6%A0%A1%E3%83%BB%E9%AB%98%E6%A0%A1%E7%AD%89%EF%BC%89.pdf")
  }
  getManualSupport() {
    window.open("https://fukuoka-prod-file.s3.ap-northeast-1.amazonaws.com/common/%E3%83%9E%E3%83%8B%E3%83%A5%E3%82%A2%E3%83%AB/%E3%82%B3%E3%83%89%E3%83%A2%E3%83%9F%E3%83%A9%E3%82%A4%E3%82%B3%E3%83%8D%E3%82%AF%E3%83%88%E3%82%B5%E3%83%BC%E3%83%93%E3%82%B9%E3%83%9E%E3%83%8B%E3%83%A5%E3%82%A2%E3%83%AB%EF%BC%88%E4%BF%9D%E8%82%B2%E6%89%80%E3%83%BB%E5%B9%BC%E7%A8%9A%E5%9C%92%E7%AD%89%EF%BC%89.pdf")
  }
}